export default "__VITE_ASSET__18f4feee__"